// src/components/VideoLimitModal.js
import React from 'react';

export default function VideoLimitModal({ open, onClose, message, remaining }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-md rounded-2xl bg-slate-900 text-slate-50 shadow-xl border border-pink-500/30">
        <div className="px-6 pt-5 pb-4">
          <h2 className="text-lg font-semibold mb-2">
            Daily video limit reached
          </h2>
          <p className="text-sm text-slate-300 mb-3">
            {message || "You've used your free private video call for today."}
          </p>

          {typeof remaining === 'number' && remaining <= 0 && (
            <p className="text-xs text-slate-400 mb-3">
              You can start another private video call tomorrow when your limit resets.
            </p>
          )}

          <div className="mt-4 space-y-2 text-sm">
            <div className="font-medium text-slate-100">
              Want more face time today?
            </div>
            <ul className="list-disc list-inside text-slate-300 text-xs space-y-1">
              <li>
                Join the <span className="font-semibold text-pink-300">Lifestyle Lounge</span> — video with the community (20 minutes free daily).
              </li>
              <li>
                Upgrade to <span className="font-semibold text-amber-300">Unity Elite</span> for extended access and perks.
              </li>
            </ul>
          </div>
        </div>

        <div className="px-6 pb-5 pt-3 flex flex-col sm:flex-row gap-2 sm:justify-end">
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-medium bg-slate-800 hover:bg-slate-700 transition"
          >
            Close
          </button>
          <a
            href="/lifestyle-lounge"
            className="inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold bg-gradient-to-r from-pink-500 to-purple-500 hover:brightness-110 transition text-white text-center"
          >
            Go to Lifestyle Lounge
          </a>
          <a
            href="/premium"
            className="inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold bg-amber-500 hover:bg-amber-400 transition text-slate-900 text-center"
          >
            View Elite plans
          </a>
        </div>
      </div>
    </div>
  );
}
